import { Link } from 'react-router';
import { LogOut, ShieldCheck, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Badge } from '@/components/ui/badge';
import { TollitLogo } from '@/components/TollitLogo';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SECURITY_SETTINGS_PATH, useSession, useSignOut } from '@/auth';
import { landingRouteFor } from '@/routes/roleRoutes';
import { messages } from '@/i18n';
import { MobileNav } from './MobileNav';

export function TopBar() {
  const session = useSession();
  const signOut = useSignOut();

  return (
    <header className="bg-background/50 border-border/20 sticky top-0 z-40 border-b px-4 py-3 backdrop-blur-md md:px-8">
      <div className="flex items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-4">
          <MobileNav />
          <Link to={landingRouteFor(session.role)} aria-label={messages.app.name}>
            <TollitLogo />
          </Link>
          <Separator orientation="vertical" className="hidden h-6 md:block" />
          <Badge variant="accent" className="hidden truncate md:inline-flex">
            {messages.roles[session.role]}
          </Badge>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" aria-label={messages.common.signedInAs}>
              <User />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>
              <span className="text-muted-foreground block text-xs">
                {messages.common.signedInAs}
              </span>
              <span className="block truncate font-medium">{session.displayName}</span>
              <span className="text-muted-foreground block truncate text-xs">{session.email}</span>
              {session.organisationName ? (
                <span className="text-muted-foreground mt-1 block truncate text-xs">
                  {messages.common.organisation}: {session.organisationName}
                </span>
              ) : null}
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link to={SECURITY_SETTINGS_PATH}>
                <ShieldCheck aria-hidden />
                {messages.mfa.securityMenuItem}
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={() => void signOut()}>
              <LogOut aria-hidden />
              {messages.common.signOut}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
